import React, { useEffect, useState } from "react";
import { Pagination, Autoplay } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import "./style.scss";

const UseSwiper = (props: Types.Cons.IGoodsSwiper) => {
  let { bannerList } = props;

  useEffect(() => {
    const Carousel = document.getElementById("banner-box");
    if (Carousel) {
      let startX = 0;
      let startY = 0;
      let moveX = 0;
      let moveY = 0;
      Carousel.addEventListener("touchstart", (e) => {
        startX = e.targetTouches[0]?.pageX;
        startY = e.targetTouches[0]?.pageY;
      });
      Carousel.addEventListener(
        "touchmove",
        (event) => {
          // console.log(event);
          moveX = event.targetTouches[0].pageX;
          moveY = event.targetTouches[0].pageY;
          // console.log(startX, startY, moveX, moveY);
          if (Math.abs(moveX - startX) > Math.abs(moveY - startY)) {
            event.preventDefault && event.preventDefault();
          }
        },
        { passive: false }
      );
    }
  });

  return (
    <div className="banner-box" id="banner-box">
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination
        loop={true}
        autoplay={true}
      >
        {bannerList.map((item) => {
          return (
            <SwiperSlide className="banner" key={item.id}>
              <img src={item.image} alt="" />
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};

export default UseSwiper;
